import { VoiceTemplateAction, VoiceTemplateActionType } from './VoiceTemplateActions';

export type PlayMessageNode = {
    parentNode?: string | null;
    type: 'play_message';
    interactions?: Record<string, string>;
    message: string;
};

export type TransferNode = {
    parentNode?: string;
    type: 'transfer';
    transferNumber: string;
};

export type DoNotDisturbNode = {
    parentNode?: string;
    type: 'do_not_disturb';
};

export type VoiceNode = PlayMessageNode | TransferNode | DoNotDisturbNode;

export type VoiceTemplateFlowState = {
    [key: string]: VoiceNode;
};

export const initialVoiceTemplateFlowState: VoiceTemplateFlowState = {
    root: {
        type: 'play_message',
        message: '',
        parentNode: null,
        interactions: {},
    },
};

export type VoiceTemplateState = {
    templateName: string;
    selectedNode: string | null;
    voiceTemplateFlowState: VoiceTemplateFlowState;
};

export const voiceTemplateInitialState: VoiceTemplateState = {
    templateName: '',
    selectedNode: 'root',
    voiceTemplateFlowState: initialVoiceTemplateFlowState,
};

export const voiceTemplateReducer = (state: VoiceTemplateState, action: VoiceTemplateAction): VoiceTemplateState => {
    switch (action.type) {
        case VoiceTemplateActionType.SET_TEMPLATE_NAME: {
            return {
                ...state,
                templateName: action.payload,
            };
        }
        case VoiceTemplateActionType.SET_PLAY_MESSAGE_CONTENT: {
            let currNodeId = state.selectedNode;
            let currNode = state.voiceTemplateFlowState[currNodeId];
            if (currNode.type === 'play_message') {
                return {
                    ...state,
                    voiceTemplateFlowState: {
                        ...state.voiceTemplateFlowState,
                        [currNodeId]: {
                            ...currNode,
                            message: action.payload,
                        },
                    },
                };
            } else {
                return state;
            }
        }
        case VoiceTemplateActionType.ADD_NODE: {
            const { nodeId, nodeData } = action.payload;
            if (state.voiceTemplateFlowState[nodeId]) {
                return state;
            }
            if (nodeData.parentNode && !state.voiceTemplateFlowState[nodeData.parentNode]) {
            }

            return {
                ...state,
                voiceTemplateFlowState: {
                    ...state.voiceTemplateFlowState,
                    [nodeId]: nodeData,
                },
            };
        }

        case VoiceTemplateActionType.DELETE_NODE: {
            const { nodeId } = action.payload;
            const nodeToDelete = state.voiceTemplateFlowState[nodeId];

            if (!nodeToDelete) {
                return state;
            }

            const newGraphState = { ...state.voiceTemplateFlowState };
            const parentNodeId = nodeToDelete.parentNode;

            delete newGraphState[nodeId];

            if (parentNodeId && newGraphState[parentNodeId]) {
                const parentNode = newGraphState[parentNodeId];
                if (parentNode.type === 'play_message' && parentNode.interactions) {
                    const newActions = { ...parentNode.interactions };
                    let actionRemoved = false;
                    for (const key in newActions) {
                        if (newActions[key] === nodeId) {
                            delete newActions[key];
                            actionRemoved = true;
                        }
                    }
                    if (actionRemoved) {
                        newGraphState[parentNodeId] = {
                            ...parentNode,
                            interactions: newActions,
                        };
                    }
                }
            }

            return {
                ...state,
                voiceTemplateFlowState: newGraphState,
            };
        }

        case VoiceTemplateActionType.ADD_INTERACTION: {
            const { parentNodeId, actionKey, childNodeId } = action.payload;
            const parentNode = state.voiceTemplateFlowState[parentNodeId];

            if (!parentNode) {
                return state;
            }
            if (parentNode.type !== 'play_message') {
                return state;
            }
            if (!state.voiceTemplateFlowState[childNodeId]) {
            }

            const newActions = { ...(parentNode.interactions || {}), [actionKey]: childNodeId };

            return {
                ...state,
                voiceTemplateFlowState: {
                    ...state.voiceTemplateFlowState,
                    [parentNodeId]: {
                        ...parentNode,
                        interactions: newActions,
                    },
                },
            };
        }

        case VoiceTemplateActionType.REMOVE_INTERACTION: {
            const { parentNodeId, actionKey } = action.payload;
            const parentNode = state.voiceTemplateFlowState[parentNodeId];

            if (!parentNode) {
                return state;
            }
            if (parentNode.type !== 'play_message') {
                return state;
            }
            if (!parentNode.interactions || !parentNode.interactions[actionKey]) {
                return state;
            }

            const newActions = { ...parentNode.interactions };
            delete newActions[actionKey];

            return {
                ...state,
                voiceTemplateFlowState: {
                    ...state.voiceTemplateFlowState,
                    [parentNodeId]: {
                        ...parentNode,
                        interactions: newActions,
                    },
                },
            };
        }

        case VoiceTemplateActionType.SET_GRAPH: {
            return {
                ...state,
                voiceTemplateFlowState: action.payload,
            };
        }

        default:
            return state;
    }
};
